var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhybrand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 101,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#why_brand_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_brand_svg__b)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_brand_svg__c)",
  fillRule: "evenodd",
  d: "M19.615 88.417c5.222.32 13.543.654 25.437.654s20.215-.335 25.437-.654c5.185-.316 9.402-4.09 9.892-9.276.377-3.971.723-9.754.723-17.583 0-7.83-.346-13.612-.721-17.582-.492-5.187-4.71-8.961-9.894-9.277-5.222-.32-13.543-.654-25.437-.654s-20.215.334-25.437.654c-5.185.316-9.402 4.09-9.892 9.276C9.346 47.947 9 53.728 9 61.558s.346 13.612.721 17.582c.492 5.186 4.71 8.961 9.894 9.277",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#9B004D",
  fillRule: "evenodd",
  d: "M51.378 75.872a.703.703 0 0 0-.695-.616h-11.24a.7.7 0 0 0-.697.616L37.65 84.65a2.11 2.11 0 0 1-2.092 1.846h-4.004a3.4 3.4 0 0 0-3.227 2.327 2.502 2.502 0 0 0 2.374 3.293h28.725a2.502 2.502 0 0 0 2.374-3.293 3.4 3.4 0 0 0-3.227-2.327h-4.004a2.11 2.11 0 0 1-2.091-1.846z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_brand_svg__d)",
  fillRule: "evenodd",
  d: "M22.753 79.589c4.58.285 11.875.585 22.304.585 10.43 0 17.725-.3 22.304-.585 4.547-.282 8.244-3.656 8.674-8.29.33-3.548.634-8.716.634-15.713s-.303-12.164-.632-15.711c-.432-4.635-4.13-8.009-8.676-8.291C62.782 31.299 55.486 31 45.057 31s-17.725.299-22.304.584c-4.546.282-8.244 3.656-8.674 8.29-.33 3.55-.634 8.716-.634 15.712s.304 12.165.633 15.712c.43 4.635 4.129 8.009 8.675 8.291",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M48.853 48.847c.484-1.498-.787-2.975-2.287-2.658a2.01 2.01 0 0 0-1.488 1.362l-3.976 12.303c-.484 1.498.787 2.975 2.287 2.658a2.01 2.01 0 0 0 1.488-1.362zm-8.994.752c.716.86.621 2.154-.212 2.893l-2.855 2.52 2.168 1.865c1.199.981.919 2.932-.505 3.513a1.94 1.94 0 0 1-2.04-.364L32.44 56.61a2.092 2.092 0 0 1-.021-3.13l4.639-4.102a1.946 1.946 0 0 1 2.802.222m10.881.705a1.947 1.947 0 0 1 2.8-.262l3.976 3.417c.946.813.956 2.307.02 3.133l-4.638 4.102c-1.163 1.026-2.968.37-3.249-1.183-.13-.72.122-1.458.662-1.934l2.852-2.52-2.168-1.866a2.095 2.095 0 0 1-.255-2.887",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19.403,
  height: 6.428,
  x: 93.449,
  y: 63.304,
  fill: "url(#why_brand_svg__e)",
  rx: 2,
  transform: "rotate(-141.56 93.45 63.304)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_brand_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.15,
  d: "m92.754 44.412-10.805 5.265-5.053 10.91-8.351-8.65-11.934-1.435 5.65-10.615-2.326-11.796 11.841 2.092 10.5-5.853 1.672 11.901 8.809 8.18z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#why_brand_svg__g)",
  strokeWidth: 0.2,
  d: "m83.88 36.305 8.702 8.08-10.676 5.202-.032.016-.015.032-4.992 10.777-8.25-8.545-.025-.026-.035-.004-11.79-1.417 5.583-10.486.017-.032-.007-.035-2.299-11.652L71.76 30.28l.035.007.031-.018 10.372-5.782 1.652 11.757.004.035z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m81.59 42.963-4.1 1.997-1.917 4.14-3.17-3.282-4.528-.545 2.144-4.028-.883-4.476 4.494.794 3.984-2.222.635 4.517 3.343 3.104z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_brand_svg__c",
  x1: 30.445,
  x2: 77.15,
  y1: 37.452,
  y2: 85.051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_brand_svg__d",
  x1: 13.445,
  x2: 97.312,
  y1: 55.835,
  y2: 58.104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_brand_svg__e",
  x1: 93.449,
  x2: 119.103,
  y1: 66.55,
  y2: 68.18,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_brand_svg__g",
  x1: 61.461,
  x2: 89.264,
  y1: 26.959,
  y2: 66.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_brand_svg__b",
  width: 96.103,
  height: 79.027,
  x: -3,
  y: 22.045,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13678",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_brand_svg__f",
  width: 44.145,
  height: 44.257,
  x: 52.611,
  y: 20.33,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13678"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13678",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.0941176 0 0 0 0 0.52549 0 0 0 0.36 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_20508_13678"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "why_brand_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  y: 0.883,
  fill: "#fff",
  rx: 20
})))));
export { SvgWhybrand as ReactComponent };
export default __webpack_public_path__ + "static/media/why.brand.3e49612a.svg";